import { Table } from "antd";
import classes from "./CustomTable.module.css";
import className from "./CustomTableApiKey.module.css";

import { Typography, Box } from "@mui/material";

const roundTo2 = (num) =>
  Math.round((Number(num) + Number.EPSILON) * 100) / 100;

const onChange = (pagination, filters, sorter, extra) => {
  console.log("params", pagination, filters, sorter, extra);
};

export const CustomTable = ({ columns, data, customClass = true }) => {
  const formattedColumns = columns.map((column) => {
    const isRoundedColumn =
      column.title === "Credit Utilized" ||
      column.title === "Response Time";

    if (isRoundedColumn) {
      return {
        ...column,
        align: "center",
        style: { fontWeight: 500 },
        render: (value) => {
          if (value === null || value === undefined) return "-";
          return roundTo2(value).toFixed(2); 
        },
      };
    }

    // Default formatting
    return {
      ...column,
      align: "center",
      style: { fontWeight: 500 },
    };
  });

  const tableClass = customClass ? classes["custom-table"] : className["custom-table"];

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #E1E7EF",
        background: "#FFF",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        padding: "20px",
        
      }}
    >
      <Table
        className={tableClass}
        columns={formattedColumns}
        dataSource={data}
        onChange={onChange}
        pagination={{
          pageSize: 8,
          showSizeChanger: false,
        }}
        total={10}
        scroll={{ x: 1024 }}
      />
    </Box>
  );
};
